import type { ReactNode } from "react";
import { CustomTypography } from "sipli-fleet-core/components";

interface UnitInfoGreyCardProps {
  icon: ReactNode;
  label: string;
  value: string;
  action?: ReactNode;
}

const UnitInfoGreyCard = ({ icon, label, value, action }: UnitInfoGreyCardProps) => (
  <div className="unit-info-grey-card">
    <div className="unit-info-grey-card-content">
      <div className="flex items-center gap-4">
        {icon}
        <CustomTypography.CustomText className="!text-[17.72px] !font-bold !text-black">
          {label}: {value || "—"}
        </CustomTypography.CustomText>
      </div>
    </div>
    {action ? <div className="unit-info-grey-card-action">{action}</div> : null}
  </div>
);

export default UnitInfoGreyCard;
